import { PlaceholderScreen } from "@/shell/PlaceholderScreen";

export default function Shop() {
  return <PlaceholderScreen title="Shop" testID="placeholder-shop" />;
}
